<div class="dialog-header accent-background mat-header">
    <span class="dialog-header-title">{{data.dialogTitle}}</span>
  </div>
 
  <div class="dialog-content mt-2">
    <p>{{data.dialogMessageLine1}}
        <!-- <br/>
    {{data.dialogMessageLine2}} -->
</p>
  </div>
  <div class="dialog-footer">
    <button style="background-color: rgba(74, 116, 54, 255); color: #fff; margin-right: 3px;" class="standard-button dialog-button" mat-raised-button [mat-dialog-close]="false" cdkFocusInitial>{{data.noButtonText}}</button>
       
    <button style="background-color: black; color: #fff" mat-raised-button color="primary" [mat-dialog-close]="true">{{data.yesButtonText}}</button>
  </div>